module.exports = __webpack_public_path__ + "img/cover-aygaz-conversion-club-infographic.07fd5183.jpg";